import '../styles/main.css';
import { React } from 'react';
import SftGlobalData from '../library/SftGlobalData';


const Footer = (props) =>  {

  let dbName = props?.db?.description ? '- ' + props.db.description : '';
  return (
    <div className={props.theme+' footer'}>
      <p className={props.theme+' footer__text'}>Powered by SoftTouch - {SftGlobalData.version} {dbName}</p>    
    </div>
  );
}

export default Footer;
